export default "__VITE_ASSET__fTGpEANs__"